import React, { useContext, useState, useEffect, useRef } from 'react';
import { Button, Switch, DatePicker, Form, Select } from 'antd'
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from '../../services/api';
import { displayMessage } from '../../helpers/messages'
import ENotificationTypes from '../../enums/ENotificationTypes'
import { fromJSON } from 'postcss';
import moment from 'moment';
import dayjs from 'dayjs';

const { Option } = Select

export default function UserFilters(props) {
    const [form] = Form.useForm()
    // const [currentFilters, setCurrentFilters] = useState({})
    const [clients, setClients] = useState([])
    const [types, setTypes] = useState([])
    const [users, setUsers] = useState([])

    let clientsList = []
    let typesList = []
    let usersList = []

    const dateRangeStart = Form.useWatch('date_range_start', form);
    const dateRangeEnd = Form.useWatch('date_range_end', form);


    const {
        mobile_mode,
        windowWidth
    } = useContext(GeneralContext)

    useEffect(() => {
        loadLists()
    }, [])


    const handleOnClearFilter = () => {
        form.setFieldsValue('by_creator', '')
        form.setFieldsValue('date_range_start', '')
        form.setFieldsValue('date_range_end', '')
    }

    const loadLists = async () => {
        try {
            // REMOVIDO TEMPORARIAMENTE POR PODER TER PROBLEMAS DE PERFORMANCE
            // clientsList = await api.user.list() 
            // setClients(clientsList.data)
            typesList = []
            Object.values(ENotificationTypes).forEach(val => typesList.push(val))
            setTypes(typesList)
            usersList = await api.user.listAdmin()
            setUsers(usersList.data)
        } catch (error) {
            console.log(error)
        }
    }


    const onSubmitForm = (values) => {
        values.date_range_start = values?.date_range_start == '' ? null : dayjs(values.date_range_start?.$d)?.format('DD/MM/YYYY')
        values.date_range_end = values?.date_range_end == '' ? null : dayjs(values.date_range_end?.$d)?.format('DD/MM/YYYY') 

        props.handleOnSearchNotifications(values)
    }

    const windowBreakpoint = windowWidth < 800 //px

    return (

        <div
            style={
                {
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    padding: 0,
                    // marginBottom: 15,
                    height: mobile_mode ? '' : props.filterHeight + "vh",
                    minHeight: mobile_mode ? '600px' : '',
                    color: 'white',
                    overflow: 'hidden',
                    border: '1px solid lightgrey',
                }
            }
        >
            <div className='flex flex-1 justify-between p-2 bg-appian-blue gap-1'>
                <span className='self-center font-bold text-lg text-fit-gray-600 flex-1 text-center'>Filtros da Consulta</span>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }} className={'bg-fit-gray-100'}>

                <Form
                    form={form}
                    className={`flex flex-1 flex-col ss:flex-row min-w-fit gap-4 flex-wrap ${mobile_mode ? 'justify-center' : ''}`}
                    layout='inline'
                    onFinish={onSubmitForm}
                >
                    <div style={{ display: 'flex', flexDirection: mobile_mode || windowWidth <= 600 ? 'column' : 'row', justifyContent: mobile_mode ? 'start' : 'space-between', width: '100%' }}>


                        <div style={{ display: 'flex', flexDirection: 'column', gap: 5, marginTop: 20, marginLeft: 5, marginRight: 5, marginBottom: 10, justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 5, justifyContent: 'space-between' }}>
                                <div style={{ display: 'flex', flexDirection: mobile_mode || windowWidth <= 1450 ? 'column' : 'row', gap: 5, justifyContent: 'space-between' }}>
                                    {/* 
                                    // REMOVIDO TEMPORARIAMENTE POR SO TER UM TYPE
                                    <div className='flex gap-2 items-center' style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row' }}>
                                        <span className='font-bold text-fit-red-900 ss:w-[160px]' >{displayMessage('NOTIFICATION_TYPE')}:</span>
                                        <Form.Item initialValue={''} className='m-0 flex-1' name={'by_type'} label={''}>
                                            <Select className={`w-full ${mobile_mode ? '' : 'ss:'}w-[300px]`} allowClear >
                                                {types.map(type => <Option key={type.code} value={type.code}>{type.description}</Option>)}
                                            </Select>
                                        </Form.Item>
                                    </div> */}
                                    {/* 
                                    // REMOVIDO TEMPORARIAMENTE POR PODER TER PROBLEMAS DE PERFORMANCE
                                    <div className='flex gap-2 items-center' style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row' }}>
                                        <span className={`font-bold text-fit-red-900 ss:w-[${windowWidth <= 1450 ? '160' : '120'}px] ${mobile_mode || windowWidth <= 1450 ? 'ml-0' : 'ml-5'}`}>{displayMessage('USER')}:</span>
                                        <Form.Item initialValue={''} className='m-0 flex-1' name={'by_user'} label={''}>
                                            <Select className={`w-full ${mobile_mode ? '' : 'ss:'}w-[200px]`} allowClear  >
                                                {clients.map(client => <Option key={client.id} value={client.id}>{client.full_name}</Option>)}
                                            </Select>
                                        </Form.Item>
                                    </div> */}
                                </div>
                                <div style={{ display: 'flex', flexDirection: mobile_mode || windowWidth <= 1450 ? 'column' : 'row', gap: 5, justifyContent: 'space-between' }}>

                                    <div className='flex gap-2 items-center' style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row' }}>
                                        <span className='font-bold text-fit-red-900 ss:w-[160px]' >{displayMessage('NOTIFICATIONS_CREATOR')}:</span>
                                        <Form.Item initialValue={''} className='m-0 flex-1' name={'by_creator'} label={''}>
                                            <Select className={`w-full ${mobile_mode ? '' : 'ss:'}w-[${windowWidth <= 1450 ? '200' : '300'}px]`} allowClear style={{ width: 300 }} >
                                                {users.map(user => <Option key={user.id} value={user.id}>{user.full_name}</Option>)}
                                            </Select>
                                        </Form.Item>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', gap: 5, alignItems: !mobile_mode && windowWidth <= 1450 ? 'baseline' : 'center' }}>
                                    <span className={`font-bold text-fit-red-900 ss:w-[160px] `} >{displayMessage('CREATION_DATE')}:</span>
                                    <div style={{ display: 'flex', flexDirection: mobile_mode || windowWidth < 1170 ? 'column' : 'row', gap: 5 }}>
                                        <Form.Item initialValue={''} className='m-0 flex-1' name={'date_range_start'} label={''}>
                                            <DatePicker className='ss:w-[200px] flex-1'
                                                placeholder={displayMessage('FROM_THIS_DATE')}
                                                format={'DD/MM/YYYY'}
                                            />
                                        </Form.Item>
                                        <Form.Item initialValue={''} className='m-0 flex-1' name={'date_range_end'} label={''}>
                                            <DatePicker
                                                className='ss:w-[200px] flex-1'
                                                format={'DD/MM/YYYY'}

                                                placeholder={displayMessage('TO_THIS_DATE')}
                                                
                                            />
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', flex: 1, flexWrap: 'wrap', padding: 8, alignItems: 'flex-end', justifyContent: windowBreakpoint ? 'center' : 'flex-end' }}>
                            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: mobile_mode ? 'center' : 'flex-end', paddingLeft: !windowBreakpoint && 8, alignItems: 'flex-end', borderLeft: !windowBreakpoint && '1px solid lightgrey', gap: 8 }}>
                                <Form.Item style={{ marginRight: 0 }}>
                                    <Button
                                        htmlType='submit'
                                        type="primary"
                                        style={{ width: 200, fontWeight: 'bold', borderRadius: 7 }}
                                    >
                                        {displayMessage('SEARCH')}
                                    </Button>
                                </Form.Item>

                                <Button
                                    style={{ width: 200, fontWeight: 'bold', borderRadius: 7 }}
                                    type="primary"
                                    danger
                                    onClick={handleOnClearFilter}
                                >
                                    {displayMessage('CLEAN_FILTERS')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </Form>

            </div>
        </div >


    )
}


